import { render, staticRenderFns } from "./infoRows.vue?vue&type=template&id=c370b96e&"
import script from "./infoRows.vue?vue&type=script&lang=ts&"
export * from "./infoRows.vue?vue&type=script&lang=ts&"
import style0 from "./infoRows.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports